import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, ViewChildren } from '@angular/core';
import { MatPaginator, MatTableDataSource, MatSelect } from '@angular/material';
import { FormBuilder } from '@angular/forms';

import { WarningComponent } from '../../../../../shared/components/warning/warning.component';
import { UserGroupService } from '../../../../../core/services/user-group.service';
import { UpdateUserGroupComponent } from './update-user-group/update-user-group.component';
import { CommonService } from 'src/app/core/services/common.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { Message } from 'src/app/core/class/message';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ResponsiveService } from '../../../../../core/services/responsive.service';
import { Router } from '@angular/router';
import {environment} from "../../../../../../environments/environment";
import { EnvService } from 'src/app/core/services/env.service';
import {AsUserService} from "../../../../../core/services/as-user.service";

@Component({
  selector: 'app-user-group',
  templateUrl: './user-group.component.html'
})
export class UserGroupComponent implements OnInit, AfterViewInit, OnDestroy {

  isTableLoading = false;
  @ViewChildren('focusInput') focusInput;
  @ViewChild('statusSelect', { static: false }) statusSelect: MatSelect;
  // displayedColumns: string[] = ['stt', 'nameGroup', 'description', 'createDate', 'status', 'symbol'];
  displayedColumns: string[] = [];

  columnDefinitions = [
    { def: "stt", showMobile: true },
    { def: "nameGroup", showMobile: true },
    { def: "description", showMobile: false },
    { def: "createDate", showMobile: false },
    { def: "status", showMobile: true },
    { def: "action", showMobile: true },
  ];

  dataSource = new MatTableDataSource();
  grUsers = [];
  paginate: {
    currentPage: number,
    pageSize: number,
    totalRow: number,
    totalPage: number,
    totalPageArray: [],
    no: []
  };

  checkFocus = true;
  grUser = {
    status: null,
    enterpriseId: localStorage.getItem('enterpriseId'),
    email: '',
    userName: '',
    page: 0,
    pageSize: 10
  };
  isFromSSO = false;
  oldData = this.grUser;
  request = {
    tenantId: localStorage.getItem('tenantId'),
    name: '',
    enterpriseId: localStorage.getItem('enterpriseId'),
    status: 'null',
    page: 0,
    pageSize: 10,
  };
  sme_hub:any
  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  constructor(
    private dialog: MatDialog,
    private fb: FormBuilder,
    private userGroupService: UserGroupService,
    private asUserService: AsUserService,
    public commonService: CommonService,
    public notificationService: NotificationService,
    private message: Message,
    private toastr: ToastrService,
    private responsiveService: ResponsiveService,
    private router: Router,
    private env:EnvService

  ) {
    this.paginate = {
      currentPage: 0,
      pageSize: 10,
      totalRow: 0,
      totalPage: 0,
      totalPageArray: [],
      no: []
    };
    this.sme_hub = env.sme_portal_url
  }

  ngOnInit() {
    this.isFromSSO = JSON.parse(localStorage.getItem('isFromSSO'));
    this.loadData();
    this.notificationService.subscribeErrorService();
    window.scrollTo(0, 0);
  }

  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showMobile)
        .map(cd => cd.def);
    } else {
      this.displayedColumns = this.columnDefinitions.map(cd => cd.def);
    }
    // if (this.commonService.getIsLockedEnterprise()) {
    //   this.displayedColumns = this.columnDefinitions
    //     .filter(cd => (cd.def !== 'action' && cd.def !== 'status'))
    //     .map(cd => cd.def);
    // }
  }

  ngAfterViewInit() {
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
    this.dataSource.paginator = this.paginator;
    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
          this.getDisplayedColumns();
        }
      }
    );
  }

  /**
   * Implement ngOnDestroy method, unsubscribe error service to avoid memory leak
   */
  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
    this.subscribeMediaBreakPointService.unsubscribe();
  }

  /**
   * Load data to init
   * @param page: current page
   * @param pageSize: item per page
   */
  loadData(page: number = 0, pageSize: number = 10) {
    this.isTableLoading = true;
    // clear data cu: skeleton la footer-row nam duoi cung bang, neu giu data cu thi no nam
    // duoi man hinh -> clear de skeleton hien ngay duoi header nhu luc vua vao trang
    this.dataSource.data = [];
    this.userGroupService.getAll({
      ...this.request,
      page,
      pageSize,
      status: [true, false]
    }).subscribe(rs => {
      this.isTableLoading = false;
      if (rs == null || rs.data == null || rs.data.dataRow == null) {
        return 0;
      }
      this.paginate = {
        currentPage: rs.data.currentPage,
        pageSize: rs.data.pageSize,
        totalRow: rs.data.totalRow,
        totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
        totalPageArray: this.commonService.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
        no: this.commonService.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
      };
      this.dataSource.data = rs.data.dataRow;
    }, () => this.isTableLoading = false);
  }

  /**
   * Open dialog add new group user
   */
  // openDialogAdd() {
  //   const dialogRef = this.dialog.open(AddUserGroupComponent, {
  //     width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : '45%',
  //     maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '90vw' : '80vw',
  //     panelClass: 'scontract-overlay-dialog',
  //     autoFocus: false
  //   });
  //   dialogRef.afterClosed().subscribe(result => {
  //     this.searchUser(this.paginate.currentPage, this.paginate.pageSize);
  //   });
  // }

  /** open dialog delete **/

  delete(id: any, name: any) {
    const dialogRef = this.dialog.open(WarningComponent, {
      width: '350px',
      data: this.commonService.format(this.message.getMessage('messages.confirm_delete_permission_group'), name)
    });
    dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        this.asUserService.removeGroupUser({ id: id } ).subscribe( result => {
          if (result.success) {
            this.toastr.success(this.message.getMessage('messages.delete_user_group_success'));
            this.loadData();
          } else {
            this.toastr.error(rs.mesage);
          }
        });
      }
    });
  }

  /**
   * Open dialog update group user
   */
  openDialogEdit(data) {
    if(this.getPermisionSME == true){
      // window.location.href = 'http://10.207.252.76:8777/admin/role-management'
      window.open(this.sme_hub+'/admin/role-management','_blank');
      return
    }
    const dialogRef = this.dialog.open(UpdateUserGroupComponent, {
      width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : '45%',
      maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '90vw' : '80vw',
      panelClass: 'scontract-overlay-dialog',
      data: {
        data
      }
    });
    this.handleDialogClose(dialogRef);
  }

  /**
   * Change status group user
   */
  onChangeStatus(id, groupName: string, groupStatus: boolean) {
    // Them trang thai cua nhom nguoi dung
    var s1 = groupStatus ? '<strong>' + this.message.getMessage('enterprise_document_template_add.cbx_document_status.cbx_document_status_active') + '</strong>'
      : '<strong>' + this.message.getMessage('enterprise_document_template_add.cbx_document_status.cbx_document_status_inactive') + '</strong>';

    var s2 = !groupStatus ? '<strong>' + this.message.getMessage('enterprise_document_template_add.cbx_document_status.cbx_document_status_active') + '</strong>'
      : '<strong>' + this.message.getMessage('enterprise_document_template_add.cbx_document_status.cbx_document_status_inactive') + '</strong>';

    const dialogRef = this.dialog.open(WarningComponent, {
      width: '350px',
      // Them ten nhom nguoi dung
      data: this.commonService.format(this.message.getMessage('messages.confirm_change_status_usGr'), groupName, s1, s2)
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.userGroupService.changeStatusUserGroup(id).subscribe(() => {
          this.toastr.success(this.message.getMessage('messages.update_status_success'));
          if (this.paginate.totalRow % this.paginate.pageSize === 1) {
            if (this.paginate.currentPage - 1 < 0) {
              this.paginate.currentPage = 0;
            } else {
              this.paginate.currentPage = this.paginate.currentPage - 1;
            }
          }
          this.searchUser(this.paginate.currentPage, this.paginate.pageSize);
        });
      }
      this.focusInput.first.nativeElement.focus()
    });
  }

  onFilterGroups() {
    let status;
    if (this.request.status == null || this.request.status === 'null') {
      status = [true, false];
    } else {
      status = [this.request.status === 'true'];
    }
    this.isTableLoading = true;
    // clear data cu: skeleton la footer-row nam duoi cung bang, neu giu data cu thi no nam
    // duoi man hinh -> clear de skeleton hien ngay duoi header nhu luc vua vao trang
    this.dataSource.data = [];
    this.userGroupService.getAll({ ...this.request, status }).subscribe(
      rs => {
        this.isTableLoading = false;
        this.dataSource.data = rs.data.dataRow;
      }, () => this.isTableLoading = false
    );
  }

  /**
   * Grant permission
   */
  // openDialogAutho(data) {
  //   const dialogRef = this.dialog.open(AuthoUserGroupComponent, {
  //     width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : '45%',
  //     maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '90vw' : '80vw',
  //     panelClass: 'scontract-overlay-dialog',
  //     data: { data }
  //   });

  //   this.handleDialogClose(dialogRef);
  // }

  private handleDialogClose(dialogRef) {
    dialogRef.afterClosed().subscribe(() => {
      this.loadData(this.paginate.currentPage, this.paginate.pageSize);
      this.focusInput.first.nativeElement.focus();
    });
  }

  /**
   * On click search group user
   * @param event: Event
   * @param pageNo: number
   */
  searchUser(page: number = 0, pageSize: number = 10) {
    let status;
    if (this.request.status == null || this.request.status === 'null') {
      status = [true, false];
    } else {
      status = [this.request.status === 'true'];
    }
    this.isTableLoading = true;
    // clear data cu: skeleton la footer-row nam duoi cung bang, neu giu data cu thi no nam
    // duoi man hinh -> clear de skeleton hien ngay duoi header nhu luc vua vao trang
    this.dataSource.data = [];
    this.userGroupService.getAll({
      ...this.request,
      status,
      page,
      pageSize,
    }).subscribe(rs => {
      this.isTableLoading = false;
      if (rs == null || rs.data == null || rs.data.dataRow == null) {
        return;
      }
      this.paginate = {
        currentPage: rs.data.currentPage,
        pageSize: rs.data.pageSize,
        totalRow: rs.data.totalRow,
        totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
        totalPageArray: this.commonService.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
        no: this.commonService.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
      };
      this.dataSource.data = rs.data.dataRow;
    }, () => this.isTableLoading = false);
  }

  checkRouter(){
    if(this.getPermisionSME == true){
      // window.location.href = 'http://10.207.252.76:8777/admin/role-management'
      window.open(this.sme_hub+'/admin/role-management','_blank');
      return
    }else{
      this.router.navigateByUrl('/home-enterprise/add-user-group')
    }}

  get getPermisionSME(){
    if(JSON.parse(localStorage.getItem('permissions')).includes(2) && localStorage.getItem('isFromSSO') =='true'){
      return true
    }
    return false
  }

}
